import React from 'react'
import { Button } from '@mantine/core'
import { useMediumScreen } from '@/hooks'
import { useFreeClaimMutation } from '../mutations'

const AirdropTaskClaimButton = () => {
  const { isMediumScreen } = useMediumScreen()

  const { mutateAsync, isLoading } = useFreeClaimMutation()

  const handleClaim = () => {
    mutateAsync()
  }

  return (
    <Button loading={isLoading} onClick={handleClaim} fullWidth={!isMediumScreen}>
      Claim
    </Button>
  )
}

export { AirdropTaskClaimButton }
